import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";
import React from "react";

const CommonEvaluationTable = ({ headers, values }) => {
    return (
        <Box
            sx={{
                maxHeight: 400,
                overflow: "auto",
                border: "1px solid #ccc",
                borderRadius: "4px",
                padding: 0,
                marginBottom: 2,
                "&::-webkit-scrollbar": {
                    width: "6px",
                    height: "6px",
                },
                "&::-webkit-scrollbar-track": {
                    backgroundColor: "#f0f0f0",
                },
                "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#ccc",
                    borderRadius: "4px",
                },
                scrollbarWidth: "thin",
                scrollbarColor: "#c1c1c1 #f1f1f1",
            }}
        >
            <TableContainer
                component={Paper}
                sx={{
                    overflow: "visible",
                    boxShadow: "none",
                    backgroundColor: "transparent",
                }}
            >
                <Table
                    stickyHeader
                    sx={{
                        minWidth: "max-content",
                        borderCollapse: "collapse",
                    }}
                >
                    <TableHead>
                        <TableRow>
                            {headers.map((header, index) => (
                                <TableCell
                                    key={`head${index}`}
                                    sx={{
                                        border: "1px solid #ccc",
                                        position: "sticky",
                                        top: 0,
                                        left: index === 0 ? 0 : "auto",
                                        zIndex: index === 0 ? 3 : 1,
                                        backgroundColor: "#1976d2",
                                        color: "#fff",
                                        textAlign: index === 0 ? "left" : "center",
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            color: "#fff",
                                            fontSize: 12,
                                            fontWeight: 400,
                                            letterSpacing: 0.4,
                                            lineHeight: "16px",
                                            textAlign: "center",
                                        }}
                                    >
                                        {header}
                                    </Typography>
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {values.map((eachRow, rowIndex) => (
                            <TableRow key={`row${rowIndex}`}>
                                {eachRow.map((eachCell, cellIndex) => {
                                    const isRatingColumn = headers[cellIndex] === "Rating";
                                    const ratingValue = isRatingColumn ? parseFloat(eachCell) : null;

                                    return (
                                        <TableCell
                                            key={`${headers[cellIndex]}${cellIndex}`}
                                            sx={{
                                                border: "1px solid #ccc",
                                                position: cellIndex === 0 ? "sticky" : "static",
                                                left: cellIndex === 0 ? 0 : "auto",
                                                zIndex: cellIndex === 0 ? 2 : 1,
                                                backgroundColor:
                                                    rowIndex === 0
                                                        ? "#e3f2fd"
                                                        : rowIndex % 2 === 0
                                                            ? "#f8f8f8"
                                                            : "#ffffff",
                                                textAlign: "center",
                                                whiteSpace: "pre-wrap",
                                            }}
                                        >

                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    color: isRatingColumn
                                                        ? ratingValue >= 3
                                                            ? "green"
                                                            : "red"
                                                        : "black",
                                                    fontSize: 14,
                                                    fontWeight: 500,
                                                    width: "160px",
                                                }}
                                                dangerouslySetInnerHTML={{
                                                    __html: eachCell.toString().replace(/\n/g, "<br>"),
                                                }}
                                            />
                                        </TableCell>
                                    );
                                })}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default CommonEvaluationTable;
